import rlIcon from '../../assests/img/rl-icon.svg';

const SplashLoading = () => {
    return (
        <div className="rl-splash-loading">
            <div className="rl-splash-loading-logo">
                <img src={rlIcon} height="200" alt="RoadLords Dispatcher" />
                <div className="rl-splash-loading-progress" />
            </div>
        </div>
    );
};

export default SplashLoading;
